module.exports = __webpack_public_path__ + "img/41.15e12a01.jpg";